import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ApiCategory {
  _id: string;
  name: { en: string; ar: string };
}

export interface CategoryListResponse {
  success: boolean;
  data: { list: ApiCategory[]; total: number };
}

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private http = inject(HttpClient);

  getCategories(): Observable<CategoryListResponse> {
    return this.http.post<CategoryListResponse>(
      `${environment.apiUrl}/api/admin/category/list`,
      { page: 1, limit: 100, filters: {} }
    );
  }
}
